import { Injectable } from '@angular/core';
import { FeatureFlag } from '@app/enums';
import { MenuItem } from '@app/interfaces';
import { Template } from '@app/models/performance/template.model';
import { MenuService } from '@app/services/menu/menu.service';

/**
 * Root menu service for browsing surveys
 */
@Injectable()
export class SurveyModuleMenuService extends MenuService {
    setBaseMenu(): void {
        this.baseMenu = SurveyModuleMenu;
    }
}

/**
 * Nested menu service for navigating within a specific Survey
 */
@Injectable()
export class SurveyMenuService extends MenuService {
    setBaseMenu(): void {
        this.baseMenu = SurveyMenu;
    }
}

const SurveyMenu: MenuItem[] = [
    {
        key: 'surveys.aggregatedData',
        link: ['../aggregated-data'],
        routerLinkExact: true,
    },
    {
        key: 'surveys.rawData',
        link: ['../raw-data'],
    },
];

const SurveyModuleMenu: MenuItem[] = [
    {
        key: 'surveys.overview',
        link: ['/surveys', 'center'],
        routerLinkExact: true,
    },
    {
        key: 'surveys.templatesTitle',
        link: ['/surveys', 'center', 'templates'],
        can: Template.performancePermission.some('search'),
        hideIfHasFeatureFlag: FeatureFlag.performanceModuleSplit,
    },
    {
        key: 'surveys.templatesTitle',
        link: ['/surveys', 'center', 'templates'],
        can: Template.surveyPermission.some('search'),
        showIfHasFeatureFlag: FeatureFlag.performanceModuleSplit,
    },
];
